import { render } from "./GameOver.vue?vue&type=template&id=dc3844aa"
import script from "./GameOver.vue?vue&type=script&lang=js"
export * from "./GameOver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__